import {PayloadAction} from "@reduxjs/toolkit";
import {notification} from "antd";
import {call, put, takeEvery} from "redux-saga/effects";
import {DELETE_GROUP} from "../../actions/index";
import {groupsApi} from "../../api/index";
import {setGroupsActionStatus} from "../../groupsSlice";

function* deleteGroup(action: PayloadAction<string>) {
  const id = action.payload;
  try {
    yield put(setGroupsActionStatus({name: "delete", status: "pending"}));
    yield call(groupsApi.delete, id);
    yield put(setGroupsActionStatus({name: "delete", status: "fulfilled"}));
    notification.success({message: "Роль успешно удалена."});
  } catch (e) {
    yield put(setGroupsActionStatus({name: "delete", status: "rejected"}));
    notification.error({message: "Произошла ошибка при удалении роли!"});
  }
}

function* deleteGroupWatcher() {
  yield takeEvery(DELETE_GROUP, deleteGroup);
}

export default deleteGroupWatcher;
